import * as React from "react";
const SvgCollapseOpened = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 5, viewBox: "0 0 9 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.11328 4.5L0.216168 0.75L8.0104 0.750001L4.11328 4.5Z", fill: "currentColor" }));
export default SvgCollapseOpened;
